var map = {
	"./upgrade-nudge-apps.svg": "BbI+",
	"./upgrade-nudge-email-support.svg": "3I9n",
	"./upgrade-nudge-multistep.svg": "FQcX",
	"./upgrade-nudge-paths.svg": "S3fq",
	"./upgrade-nudge-zaps.svg": "sIwE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "luP7";